import PropTypes from 'prop-types';
import ProductRelationCard from './ProductRelationCard';
import ProductComparisonCard from './ProductComparisonCard';

export const variants = {
  relation: 'relation',
  comparison: 'comparison'
};

const ProductCard = ({ variant, ...props }) => {
  if (variant === variants.relation) {
    return <ProductRelationCard {...props} />;
  } else if (variant === variants.comparison) {
    return <ProductComparisonCard {...props} />;
  } else {
    throw new Error(`unimplemented Product Card ${variant}`);
  }
};

ProductCard.propTypes = {
  variant: PropTypes.oneOf(Object.values(variants))
};

export default ProductCard;
